import type { MethodologyDeep, MethodologyDeepPayload, MethodologyEntity } from '@protector/entities/methodology/models';

export const MethodologyDeepActionTypes = {
  LOAD_METHODOLOGY_DEEP: '[Methodology] Load Methodology Deep',
  LOAD_METHODOLOGY_DEEP_SUCCESS: '[Methodology] Load Methodology Deep Success',
  LOAD_METHODOLOGY_DEEP_FAILURE: '[Methodology] Load Methodology Deep Failure',

  UPDATE_METHODOLOGY_DEEP: '[Methodology] Update Methodology Deep',
  UPDATE_METHODOLOGY_DEEP_SUCCESS: '[Methodology] Update Methodology Deep Success',
  UPDATE_METHODOLOGY_DEEP_FAILURE: '[Methodology] Update Methodology Deep Failure'
} as const;

export const LoadMethodologyDeep = (methodology: MethodologyEntity) => {
  return {
    type: MethodologyDeepActionTypes.LOAD_METHODOLOGY_DEEP,
    payload: methodology
  };
};

export const LoadMethodologyDeepSuccess = (methodologyDeep: MethodologyDeep) => {
  return {
    type: MethodologyDeepActionTypes.LOAD_METHODOLOGY_DEEP_SUCCESS,
    payload: methodologyDeep
  };
};

export const LoadMethodologyDeepFailure = (error: string) => {
  return {
    type: MethodologyDeepActionTypes.LOAD_METHODOLOGY_DEEP_FAILURE,
    payload: error
  };
};

export const UpdateMethodologyDeep = (methodologyPayload: MethodologyDeepPayload) => {
  return {
    type: MethodologyDeepActionTypes.UPDATE_METHODOLOGY_DEEP,
    payload: methodologyPayload
  };
};

export const UpdateMethodologyDeepSuccess = (methodology: MethodologyDeep) => {
  return {
    type: MethodologyDeepActionTypes.UPDATE_METHODOLOGY_DEEP_SUCCESS,
    payload: methodology
  };
};

export const UpdateMethodologyDeepFailure = (error: string) => {
  return {
    type: MethodologyDeepActionTypes.UPDATE_METHODOLOGY_DEEP_FAILURE,
    payload: error
  };
};
